(function () {
  if (window.CircleMenuProAjaxNav) return;
  window.CircleMenuProAjaxNav = true;

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function collectRoots() {
    return qsa('[data-circle-menu-ajax="1"]');
  }

 function normalizePath(p) {
  p = (p || '').split('?')[0].split('#')[0];
  if (!p) return '';
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  if (p[0] !== '/') p = '/' + p;
  return p;
}

function getCfg(root) {
  var meta = document.querySelector('.db-intro-meta[data-db-intro-path]');
  return {
    root: root,
    doScroll: root.getAttribute('data-scroll-into-view') === '1',
    scrollOffset: parseInt(root.getAttribute('data-scroll-offset') || '150', 10) || 150,
    syncToggle: root.getAttribute('data-sync-dream-toggle') === '1',
    introPath: normalizePath(meta ? (meta.getAttribute('data-db-intro-path') || '') : ''),
    introSectionId: meta ? (meta.getAttribute('data-db-intro-section-id') || '') : ''
  };
}

  function dbScrollToCollection(target, refs, cfg) {
    if (!cfg.doScroll) return;
    if (!target) target = document.querySelector('section.shopify-section--main-collection') || (refs && refs.main) || null;
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var baseTop = window.pageYOffset + rect.top;
    var header = document.querySelector('.shopify-section-header, header.site-header, .section-header');
    var headerH = header ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: baseTop - headerH - cfg.scrollOffset, behavior: 'smooth' });
  }

  var KEY = 'db_dream_view';
  var boundToggle = null;

  function getToggle() { return document.getElementById('db-dream-toggle'); }
  function getStateRaw() { try { var v = localStorage.getItem(KEY); return v === null ? null : (v === '1'); } catch (e) { return null; } }
  function setState(v) { try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }

  function reflect(trigger) {
    var n = getToggle(); if (!n) return;
    var st = getStateRaw(); if (st === null) return;
    if (n.checked !== st) { n.checked = st; if (trigger) n.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function onToggleChange() { var n = getToggle(); if (n) setState(!!n.checked); }

  function bindIfNeeded() {
    var n = getToggle();
    if (!n) return false;
    if (boundToggle !== n) {
      if (getStateRaw() === null) setState(!!n.checked);
      if (boundToggle) boundToggle.removeEventListener('change', onToggleChange);
      n.addEventListener('change', onToggleChange);
      boundToggle = n;
    }
    return true;
  }

  function ensureToggleSyncedSoon() {
    var tries = 0;
    function attempt() {
      if (bindIfNeeded()) { reflect(true); }
      else if (tries < 6) { tries++; (window.requestAnimationFrame || setTimeout)(attempt, 0); }
    }
    attempt();
  }

  function findMainSection() {
    var s = document.querySelector('[id^="shopify-section-"].shopify-section--main-collection');
    if (s) return s;
    var all = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('product-facet, .product-facet, .product-facet__main, product-list, .collection-product-grid, .product-grid, [data-product-grid], #CollectionProductGrid, .product-list__inner')) return all[i];
    }
    return null;
  }

  function findBannerSection() {
    var s = document.querySelector('[id^="shopify-section-"].shopify-section--collection-banner');
    if (s) return s;
    var all = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('.collection-hero, .collection-banner, .collection__title, .page-title')) return all[i];
    }
    return null;
  }

function getCollectionSections(cfg, targetUrl) {
  var banner = findBannerSection();
  var main = findMainSection();

  var tabsHost = null;
  var tabsInner = document.querySelector('[data-scrollable-tabs-root]');
  if (tabsInner) tabsHost = tabsInner.closest('[id^="shopify-section-"]');

  if (!tabsHost) {
    var tabsPlaceholder = document.querySelector('[data-scrollable-tabs-placeholder]');
    if (tabsPlaceholder) tabsHost = tabsPlaceholder.closest('[id^="shopify-section-"]');
  }

  var ids = [];
  if (main && main.id) ids.push(main.id.replace('shopify-section-', ''));
  if (banner && banner.id) ids.push(banner.id.replace('shopify-section-', ''));
  if (tabsHost && tabsHost.id) ids.push(tabsHost.id.replace('shopify-section-', ''));

  var introInvolved = false;
  if (cfg && cfg.introPath) {
    var cur = normalizePath(window.location.pathname);
    var nxt = normalizePath(targetUrl && targetUrl.pathname ? targetUrl.pathname : '');
    introInvolved = (cur === cfg.introPath || nxt === cfg.introPath);
  }
  if (introInvolved && cfg.introSectionId) ids.push(String(cfg.introSectionId));

  ids = ids.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  return { ids: ids, main: main, banner: banner, tabs: tabsHost };
}


  function markLoading(on, refs) {
  [refs.banner, refs.main, refs.tabs].forEach(function (el) {
      if (!el) return;
      if (on) el.classList.add('is-loading');
      else el.classList.remove('is-loading');
    });
  }

  function runInlineScripts(rootEl) {
    if (!rootEl) return;

    qsa('script:not([src]):not([type]), script[type="text/javascript"]:not([src])', rootEl).forEach(function (old) {
      // NON rieseguire inline script marcati (es. intro slideshow custom)
      if (old.hasAttribute('data-no-ajax-reexec')) return;

      // dedupe opzionale via id logico
      var sid = old.getAttribute('data-script-id');
      if (sid) {
        window.__cmExecutedInline = window.__cmExecutedInline || Object.create(null);
        if (window.__cmExecutedInline[sid]) return;
        window.__cmExecutedInline[sid] = 1;
      }

      var s = document.createElement('script');
      if (old.defer) s.defer = true;
      s.text = old.textContent;
      document.head.appendChild(s);
      s.remove();
    });
    // NON rilanciare DOMContentLoaded ad ogni swap AJAX.
    // Usa gli eventi custom già presenti (pagination:page-changed, ajaxContentLoaded).
  }

  function replaceSections(htmlMap) {
    var newNodes = [];
    Object.keys(htmlMap || {}).forEach(function (id) {
      var html = htmlMap[id]; if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = ('' + html).trim();
      var newEl = tmp.firstElementChild;
      var oldEl = document.getElementById('shopify-section-' + id);
      if (newEl && oldEl) { oldEl.replaceWith(newEl); newNodes.push(newEl); }
    });
    return newNodes;
  }

  function swapMainContentDoc(newDoc) {
    var newMain = newDoc.getElementById('MainContent') || newDoc.querySelector('main[role="main"]');
    var oldMain = document.getElementById('MainContent') || document.querySelector('main[role="main"]');
    if (newMain && oldMain) { oldMain.replaceWith(newMain); runInlineScripts(newMain); }
    var t = newDoc.querySelector('title');
    if (t) document.title = t.textContent;
  }

  function fetchFullDocument(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) { return (new DOMParser()).parseFromString(html, 'text/html'); });
  }

  function isInternalCollection(href) {
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return false;
      var path = u.pathname.replace(/\/$/, '');
      return /^\/(?:[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/)?collections\//.test(path);
    } catch (_) { return false; }
  }

  function afterSwap(scrollToNode, href, refs, cfg) {
    document.dispatchEvent(new CustomEvent('pagination:page-changed', { detail: { url: href } }));
    document.dispatchEvent(new Event('ajaxContentLoaded'));
    markLoading(false, refs);
    if (cfg.syncToggle) ensureToggleSyncedSoon();
  }

  function getSwitching(root) { return !!root.__cmSwitching; }
  function setSwitching(root, v) { root.__cmSwitching = !!v; }

  function finishAndPush(scrollToNode, href, refs, cfg, urlObj) {
    window.history.pushState({}, '', urlObj.pathname + urlObj.search);
    var target = document.querySelector('section.shopify-section--main-collection') || scrollToNode || refs.main;
    dbScrollToCollection(target, refs, cfg);
    setSwitching(cfg.root, false);
    afterSwap(scrollToNode, href, refs, cfg);
  }

  function handleClick(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var root = link.closest('[data-circle-menu-ajax="1"]');
    if (!root) return;

    var href = link.getAttribute('href') || '';
    if (!href || !isInternalCollection(href)) return;

    e.preventDefault();

    if (getSwitching(root)) return;
    setSwitching(root, true);

    var cfg = getCfg(root);
    var url = new URL(href, window.location.origin);
var refs = getCollectionSections(cfg, url);
    if (refs.ids.length) {
      var sUrl = new URL(href, window.location.origin);
      sUrl.searchParams.set('sections', refs.ids.join(','));
      markLoading(true, refs);

      fetch(sUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (map) {
          var newNodes = replaceSections(map);
          var mainWasReplaced = newNodes.some(function (n) { return n.classList && n.classList.contains('shopify-section--main-collection'); });

          if (!mainWasReplaced || !newNodes.length) {
            var chain = Promise.resolve(), collected = [];
            refs.ids.forEach(function (id) {
              chain = chain.then(function () {
                var one = new URL(href, window.location.origin);
                one.searchParams.set('section_id', id);
                return fetch(one.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
                  .then(function (r) { return r.ok ? r.text() : ''; })
                  .then(function (html) {
                    if (!html) return;
                    var tmp = document.createElement('div'); tmp.innerHTML = html.trim();
                    var newEl = tmp.firstElementChild;
                    var oldEl = document.getElementById('shopify-section-' + id);
                    if (newEl && oldEl) { oldEl.replaceWith(newEl); collected.push(newEl); }
                  });
              });
            });

            return chain.then(function () {
              if (collected.length) {
                collected.forEach(runInlineScripts);
                finishAndPush(collected.find(function (n) { return n.classList.contains('shopify-section--main-collection'); }), href, refs, cfg, url);
              } else {
                return fetchFullDocument(href).then(function (doc) {
                  swapMainContentDoc(doc);
                  finishAndPush(doc.querySelector('section.shopify-section--main-collection'), href, refs, cfg, url);
                });
              }
            });
          }

          newNodes.forEach(runInlineScripts);
          finishAndPush(newNodes.find(function (n) { return n.classList.contains('shopify-section--main-collection'); }), href, refs, cfg, url);
        })
        .catch(function () {
          fetchFullDocument(href).then(function (doc) {
            swapMainContentDoc(doc);
            finishAndPush(doc.querySelector('section.shopify-section--main-collection'), href, refs, cfg, url);
          });
        });

    } else {
      fetchFullDocument(href).then(function (doc) {
        swapMainContentDoc(doc);
        finishAndPush(doc.querySelector('section.shopify-section--main-collection'), href, refs, cfg, url);
      });
    }
  }

  function boot() {
    var roots = collectRoots();
    if (!roots.length) return;
    document.addEventListener('click', handleClick, true);
    var anySync = roots.some(function (r) { return r.getAttribute('data-sync-dream-toggle') === '1'; });
    if (anySync) ensureToggleSyncedSoon();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      if (!document.__cmAjaxRebooted) {
        document.__cmAjaxRebooted = true;
        setTimeout(function(){ document.__cmAjaxRebooted = false; }, 0);
      }
    });
    document.addEventListener('shopify:section:unload', function () {
      if (!document.__cmAjaxRebooted) {
        document.__cmAjaxRebooted = true;
        setTimeout(function(){ document.__cmAjaxRebooted = false; }, 0);
      }
    });
  }
})();
